import * as React from 'react';
import { HashRouter as Router } from 'react-router-dom';

import { createReactRenderer } from 'helpers/react-renderer';
import GlobalEvents from 'app/GlobalEvents';
import { Eventbus } from 'app/src/data/Eventbus';

import { PaymentsPanelComponent } from './PaymentsPanelComponent';

let RenderedComponent: TSFixMe;

if (!RenderedComponent) {
  const PaymentsPanelComponentWithRouter = () => (
    <Router>
      <PaymentsPanelComponent />
    </Router>
  );

  RenderedComponent = createReactRenderer({
    component: PaymentsPanelComponentWithRouter,
    selector: '[data-react-root="payments_panel"]',
  });
}

history.onChangeState(
  // @ts-expect-error ts-migrate(2322) FIXME: Type '{ pathname: string; form_name: string; }' is... Remove this comment to see the full error message
  [{ pathname: '/register.php', form_name: 'do_payments' }],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);

/**
 * This function should be used to re-trigger the display of the Payment Panel.
 *
 * The register view is based on GUI_Defs and the dom elements that gets refreshed
 * on each re-render actions. This can leads to event being emitted before
 * the component is mounted.
 *
 * This function will then check if the element is present in the Dom and retry
 * in case it's not.
 *
 */
const reTriggerShowPaymentEvent = (data: TSFixMe) => {
  setTimeout(() => {
    const node =
      RenderedComponent.nodes.length > 0
        ? RenderedComponent.nodes[0]
        : { firstChild: { childElementCount: 0 } };

    const isJSReadyBeforeDOM = node.firstChild.childElementCount === 0;
    if (isJSReadyBeforeDOM) {
      RenderedComponent.mount();
      Eventbus.emit(GlobalEvents.Events.register.SHOW_PAYMENTS, { data });
    }
  }, 100);
};
history.onChangeState(
  // @ts-expect-error ts-migrate(2322) FIXME: Type '{ pathname: string; }' is not assignable to ... Remove this comment to see the full error message
  [{ pathname: '/register.php' }],
  () => {
    Eventbus.listen({
      eventName: GlobalEvents.Events.register.SHOW_PAYMENTS,
      callbackFn: reTriggerShowPaymentEvent,
    });
  },
  () => {
    Eventbus.unSubscribe(GlobalEvents.Events.register.SHOW_PAYMENTS, reTriggerShowPaymentEvent);
  }
);
